<template>
  <div class="page" :style="{height: windowHeight + 'px'}" data-flex="dir:top main:center cross:center">
    <p data-flex-box="0">我的订单页面</p>
  </div>
</template>

<script>
import mix1 from '@/mixins/page'

export default {
  mixins: [mix1],
  mounted() {
    console.log(this.$router)
    console.log(this.$route)
  }
}
</script>

<style lang="less" scoped>
.page {}
</style>